// Libraries
import React from 'react'

// Styles
import { Caption, Column, Description, Row, TextOutlined, Title, Vertical, Wrap } from './style'
import { TextOutlinedL } from '../../pages/StageOne/TextOutlinedL'

interface PropsInterface {
  children?: any[] | any | JSX.Element[] | JSX.Element;
  stage?: number | string;
  title?: string | JSX.Element[] | JSX.Element;
  description?: string | JSX.Element[] | JSX.Element;
  textAlign?: string;
  caption?: string;
  heading?: JSX.Element;
}

export const MainWrapperWithCaptions = ({ children, stage, caption, description, textAlign, title }: PropsInterface) => {
  return (
    <Wrap initial={{ opacity: .6 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, ease: 'easeInOut' }}>
      <Row>
        <TextOutlinedL>{stage}</TextOutlinedL>
        {stage && <Vertical />}
        <Column>
          <Title $textAlign={textAlign}>{title}</Title>
          <Description $textAlign={textAlign}>{description}</Description>
        </Column>
        <Caption>{caption}</Caption>
      </Row>
      {children}
    </Wrap>
  )
}
